import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ServiceStatus } from "@/models/enums/service";
import Service from "@/services";
import { SubZoneModel, ZoneModel } from "@/models/classes/zone";

interface ZoneSliceState {
  zones: {
    network: {
      code: ServiceStatus;
      error?: string;
    };
    data?: ZoneModel[];
  };
  subZones: {
    network: {
      code: ServiceStatus;
      error?: string;
    };
    zoneId?: number;
    data?: SubZoneModel[];
  };
}

const service = new Service.ZoneService();

const initialState: ZoneSliceState = {
  zones: {
    network: {
      code: ServiceStatus.idle,
    },
    data: undefined,
  },
  subZones: {
    network: {
      code: ServiceStatus.idle,
    },
    zoneId: undefined,
    data: undefined,
  },
};


export const slice = createSlice({
  name: "zone",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(onFetchZonePolygon.pending, (state) => {
      state.zones.network.code = ServiceStatus.loading;
      state.zones.network.error = undefined;
    });
    builder.addCase(onFetchZonePolygon.fulfilled, (state, action) => {
      state.zones.network.code = ServiceStatus.succeeded;
      state.zones.data = action.payload;
    });
    builder.addCase(onFetchZonePolygon.rejected, (state, action) => {
      state.zones.network.code = ServiceStatus.failed;
      state.zones.network.error = action.payload as string;
    });

    builder.addCase(onFetchSubZonePolygon.pending, (state) => {
      state.subZones.network.code = ServiceStatus.loading;
      state.subZones.network.error = undefined;
    });
    builder.addCase(onFetchSubZonePolygon.fulfilled, (state, action) => {
      state.subZones.network.code = ServiceStatus.succeeded;
      state.subZones.zoneId = action.payload.zoneId;
      state.subZones.data = action.payload.data;
    });
    builder.addCase(onFetchSubZonePolygon.rejected, (state, action) => {
      state.subZones.network.code = ServiceStatus.failed;
      state.subZones.network.error = action.payload as string;
    });
  },
});

export const onFetchZonePolygon = createAsyncThunk("zone/polygon", async (_, thunkAPI) => {
  try {
    const response = await service.fetchZonePolygon();
    return response;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data?.message ?? "Failed to fetch zone polygon");
  }
});

export const onFetchSubZonePolygon = createAsyncThunk("zone/subZone", async (zoneId: number, thunkAPI) => {
  try {
    const response = await service.fetchSubZonePolygon(zoneId);
    return { zoneId, data: response };
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data?.message ?? "Failed to fetch sub-zone polygon");
  }
});


export const { reset } = slice.actions;
export default slice.reducer;
